export default {
	data: () => ({
		langRo: {
			author: {
				btn: 'Vezi toată istoria'
			}
		}
	})
}